import { css } from '@emotion/core'
import React, { type ReactNode } from 'react'

const childItemCss = css`
  list-style: none;
  padding: 0;
  margin: 0;

  & + &,
  &:first-of-type {
    margin-bottom: 4px;
  }
`

type Props = {
  children: ReactNode
  /** Hinted children use their own test id so they are never counted as real children. */
  testId?: string
}

export default function ChildListItemWrapper({ children, testId = 'child-person' }: Props): JSX.Element {
  return (
    <li css={childItemCss} data-testid={testId}>
      {children}
    </li>
  )
}
